import type {FC} from 'react';

type Props = {
  companyName?: string;
  departmentLabel?: string;
  stepName?: string;
};

/**
 * 選択済み情報表示ボックス
 * 企業名、部門・職種、ステップ名などの選択済み情報を表示するコンポーネント
 * 値がある項目のみを表示し、全項目が空の場合はボックス自体を表示しない
 */
export const SelectedInfoBox: FC<Props> = ({
  companyName,
  departmentLabel,
  stepName,
}) => {
  // 表示する情報が1つもない場合は何も表示しない
  if (!companyName && !departmentLabel && !stepName) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 text-sm text-black-2 bg-background-1 rounded-8 px-12 py-8 w-full">
      {companyName && (
        <div className="flex gap-4">
          <span className="text-black-3 shrink-0">企業:</span>
          <span className="font-bold">{companyName}</span>
        </div>
      )}
      {departmentLabel && (
        <div className="flex gap-4">
          <span className="text-black-3 shrink-0">部門・職種:</span>
          <span className="font-bold">{departmentLabel}</span>
        </div>
      )}
      {stepName && (
        <div className="flex gap-4">
          <span className="text-black-3 shrink-0">ステップ:</span>
          <span className="font-bold">{stepName}</span>
        </div>
      )}
    </div>
  );
};
